// extracted by mini-css-extract-plugin
module.exports = {"feedbackRatingBox":"Feedback_feedbackRatingBox__3HBup","helpLink":"Feedback_helpLink__3ULiM","helpCallout":"Feedback_helpCallout__SvBX7","comment":"Feedback_comment__3c1Tk"};